export { default } from './RichTextBody'
